import {useIntl} from 'react-intl';
import {DeprecatedText as Text, IconTooltip} from '@forecast-it/design-system';
import {ForecastTooltipFormulaRenderer} from '../../../../components/ForecastTooltipFormulaRenderer';
import React from 'react';
import styled from 'styled-components';
import Util from '../../util/util';

const NUMBER_TYPE = {
	MONEY: 'MONEY',
	PERCENTAGE: 'PERCENTAGE',
};
const formatNumber = (value, numberType, currencySymbol, intl) => {
	switch (numberType) {
		case NUMBER_TYPE.MONEY:
			return currencySymbol ? Util.getFormattedNumberWithCurrency(currencySymbol, value, intl) : value;
		case NUMBER_TYPE.PERCENTAGE:
			return Util.getFormattedPercentage(value, intl);
		default:
			break;
	}
	return value;
};

const Grid = styled.div.attrs({'data-financial-grid': ''})`
	display: grid;
	grid-template-columns: max-content 1fr;
	column-gap: 12px;
	row-gap: 16px;
	align-items: baseline;
	width: 100%; /* fills the SummaryCard FlexRow item; without this 1fr has no space to distribute */
`;

const ValueCell = styled.div.attrs({'data-financial-value': ''})`
	grid-column: ${({fullWidth}) => (fullWidth ? '1 / -1' : 'auto')};
`;

const LabelCell = styled.div`
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
	gap: 4px;
`;

// Returns a React fragment of grid cells; must be rendered inside FinancialNumber.Grid.
const FinancialNumber = ({
	labelTranslationId,
	label,
	cy,
	tooltipItem,
	value,
	type = 'heading',
	variant = 'm',
	numberType,
	currencySymbol,
	currency,
	zeroValuesHidden = false,
}) => {
	const intl = useIntl();
	if (zeroValuesHidden && value === 0) {
		return null;
	}
	const theCurrencySymbol = currencySymbol || Util.GetCurrencySymbol(currency);
	const theLabel = label ? label : labelTranslationId ? intl.formatMessage({id: labelTranslationId}) : undefined;
	return (
		<>
			<ValueCell fullWidth={!theLabel} data-testid={cy ? `${cy}-value` : undefined}>
				<Text type={type} variant={variant} color={value < 0 ? 'destructive' : 'primary'} noWrap={true} data-cy={cy}>
					{formatNumber(value, numberType, theCurrencySymbol, intl)}
				</Text>
			</ValueCell>

			{theLabel && (
				<LabelCell data-testid={cy ? `${cy}-label` : undefined}>
					<Text type={type} variant={variant} color={'primary'}>
						{theLabel}
					</Text>
					{tooltipItem && tooltipItem.details.map ? (
						<IconTooltip>
							<ForecastTooltipFormulaRenderer items={[tooltipItem]} translatedMessage={true} />
						</IconTooltip>
					) : (
						tooltipItem && (
							<IconTooltip>
								<IconTooltip.Item content={tooltipItem} />
							</IconTooltip>
						)
					)}
				</LabelCell>
			)}
		</>
	);
};

FinancialNumber.NUMBER_TYPE = NUMBER_TYPE;
FinancialNumber.Grid = Grid;

export default FinancialNumber;
